import RedeemPage from "./components/RedeemPage";

const AppRoutes = [
  {
    index: true,
    element: <RedeemPage />
  },
  {
    path: '/redeem',
    element: <RedeemPage />
  },
];

export default AppRoutes;
